import React from 'react';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
import { ResponseAnswer } from 'routes/screens/contacts/components/ResponseCard/ResponseAnswer';
import { Comment } from 'routes/screens/response/screens/view/components/questionComments/index';
import {
  AccountInfoType,
  PageDataType,
  SurveyBlockWithQuestionType,
  SurveyQuestionType,
  SurveyResponseDetailedDataType,
  SurveyResponseType,
  SurveyType,
} from 'shared/types';
import { StyledQuestionTitle } from '../style';

type ResponseCardBlockProps = {
  survey: SurveyType;
  block: SurveyBlockWithQuestionType;
  response: SurveyResponseType;
  question?: SurveyQuestionType;
  questionName?: string;
  questionTitle?: string;
  detailed_data: SurveyResponseDetailedDataType[];
  page_data?: PageDataType[];
  accountInfo?: AccountInfoType;
  respondedQuestionAnswer?: SurveyResponseDetailedDataType;
  resolvedQuestionAnswer?: any;
  isFetchedTranslation?: boolean;
};

const ResponseCardBlock = (props: ResponseCardBlockProps) => {
  const {
    survey,
    block,
    response,
    question,
    questionName,
    questionTitle,
    detailed_data,
    page_data,
    accountInfo,
    isFetchedTranslation,
    respondedQuestionAnswer,
    resolvedQuestionAnswer,
  } = props;
  const { t } = useTranslation();
  const { question_answers } = response;

  if (question?.name) {
    const questionScore = respondedQuestionAnswer?.score;

    return (
      <div className="response-question-card">
        <span className="question-number">{questionName + '.\u00A0'}</span>
        <div className="question">
          <div className="question-wrap">
            <div className="title">
              <span className="quesion-title-wrapper" id="wrapper">
                {questionTitle !== '' && (
                  <>
                    <StyledQuestionTitle
                      key={question.name}
                      theme={question.type_info?.question_theme}
                      deletedText={t('deleted_question')}
                      isDeleted={block.is_deleted}
                      dangerouslySetInnerHTML={{
                        __html: `${questionTitle} ` || '',
                      }}
                    />
                  </>
                )}
              </span>
            </div>
            {!isNil(questionScore) && (
              <div className="score-chip">
                <span className="given-score">
                  {questionScore?.given_score}
                </span>
                <span className="max-score">{questionScore?.max_score}</span>
              </div>
            )}
          </div>
          <ResponseAnswer
            resolvedQuestionAnswer={resolvedQuestionAnswer}
            question={question}
            block={block}
            isFetchedTranslation={isFetchedTranslation}
            accountInfo={accountInfo}
            surveyInfo={survey}
            answer={question_answers}
            responsesToShow={detailed_data}
            responseId={response?.surveyserv_response_id}
          />
          {!!respondedQuestionAnswer?.others_answer && (
            <Comment comments={respondedQuestionAnswer?.others_answer} />
          )}
        </div>
      </div>
    );
  }
  return null;
};

export default ResponseCardBlock;
